module.exports = __webpack_public_path__ + "img/logoNew.e558f48f.png";